import styled from 'styled-components'

import { Link as RouteLink } from 'react-router-dom'

import { theme } from '../../styles/theme'

export const Content = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  gap: 16px;

  @media (min-width: 768px) {
    & > div {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
  }
`

export const Avatar = styled.img`
  width: 100px;
  height: 100px;

  border-radius: 50%;

  object-fit: cover;
  object-position: center;
`

export const ContractorInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  @media (min-width: 768px) {
    flex-direction: row;
    gap: 16px;
  }
`

export const Name = styled.div`
  font-size: ${theme.font.sizes.normal};
  font-weight: ${theme.font.bold};
  color: ${theme.colors.white};

  display: flex;
  align-items: center;
  gap: 8px;
`

export const InfoDetails = styled(RouteLink)`
  display: flex;
  align-items: center;
  gap: 6px;

  text-decoration: none;

  svg {
    width: 16px;
    height: 16px;

    path {
      fill: ${theme.colors.lightGreen};
    }
  }
`

export const Info = styled.div`
  font-size: ${theme.font.sizes.small};
  color: ${theme.colors.lightGreen};
  line-break: anywhere;
`

export const EditImageLink = styled(RouteLink)`
  text-decoration: none;
  font-size: ${theme.font.sizes.small};
  color: ${theme.colors.lightGreen};
  font-weight: ${theme.font.medium};

  margin-left: 12px;
`
